<template>
  <div class="unsupported-page">
    <div class="unsupported-page__header">
      <visualiser-logo class="unsupported-page__header-logo" />
      <badge class="unsupported-page__header-badge" text="BETA" />
    </div>
    <div class="unsupported-page__divider">
    </div>
    <div class="unsupported-page__title">
      <slot name="title" />
    </div>
    <div class="unsupported-page__body">
      <slot name="body" />
    </div>
  </div>
</template>
<script setup lang="ts">
import VisualiserLogo from '@/assets/VisualiserLogo.svg'
import Badge from '@/components/nav/Badge.vue'
</script>
<style lang="scss">
#app {
  min-width: auto;
}

.unsupported-page {
  height: 100%;
  width: 100%;
  background-color: rgba($black, 0.45);
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;

  &__header {
    margin-top: 80px;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: 8px;
    height: 24px;

    @media (min-width: 376px) {
      height: 32px;
      margin-top: 86px;
    }

    &-logo {
      height: 100%;
      width: auto;
      padding-top: 1px;
      padding-left: 1px;
    }

    &-badge {
      height: 21px;
      color: $white;
      border-color: $white;
      margin-bottom: 2px;
    }
  }

  &__divider {
    height: 1px;
    background-color: $grey-80;
    margin-top: 24px;
    width: 75vw;

    @media (min-width: 376px) {
      margin-top: 38px;
    }
  
    @media (min-width: 560px) {
      width: 550px;
    }
  }

  &__title {
    width: 25%;
    font-size: 16px;
    color: white;
    margin-top: 32px;
    text-align: center;
    font-family: $font-light;
    line-height: 28px;
    min-width: 300px;

    @media (min-width: 376px) {
      font-size: 20px;
    }
  }

  &__body {
    margin-top: 40px;
    display: flex;
    flex-direction: row;

    a {
      color: $link-blue;
      text-decoration: none;
      font-size: 16px;
      font-weight: 500;

      @media (min-width: 376px) {
        font-size: 20px;
      }
    }
  }
}
</style>
